import init, {
  bbs_bls12_381_shake_256_sign,
  bbs_bls12_381_shake_256_verify,
  bbs_bls12_381_shake_256_proof_gen,
  bbs_bls12_381_shake_256_proof_verify,
  bls12_381_bbs_g1_bls_sig_g2_sha_256_generate_bbs_key_pair,
} from '@mattrglobal/pairing-crypto/lib/web/index.js';

const DEFAULT_BLS12381_PRIVATE_KEY_LENGTH = 32;
const DEFAULT_BLS12381_PUBLIC_KEY_LENGTH = 96;
const DEFAULT_BLS12381_BBS_SIGNATURE_LENGTH = 80;

let initPromise: Promise<void> | null = null;

async function ensureInitialized(): Promise<void> {
  initPromise ??= init().then(() => undefined);
  await initPromise;
}

export const bbs = {
  bls12381_sha256: {
    PRIVATE_KEY_LENGTH: DEFAULT_BLS12381_PRIVATE_KEY_LENGTH,
    PUBLIC_KEY_LENGTH: DEFAULT_BLS12381_PUBLIC_KEY_LENGTH,
    SIGNATURE_LENGTH: DEFAULT_BLS12381_BBS_SIGNATURE_LENGTH,

    async generateKeyPair(request?: { ikm?: Uint8Array }) {
      await ensureInitialized();
      const result = await bls12_381_bbs_g1_bls_sig_g2_sha_256_generate_bbs_key_pair(request ?? {});
      return {
        secretKey: new Uint8Array(result.secretKey),
        publicKey: new Uint8Array(result.publicKey),
      };
    },

    async sign(request: unknown) {
      await ensureInitialized();
      return new Uint8Array(await bbs_bls12_381_shake_256_sign(request));
    },

    async verify(request: unknown) {
      await ensureInitialized();
      return bbs_bls12_381_shake_256_verify(request);
    },

    async deriveProof(request: unknown) {
      await ensureInitialized();
      return new Uint8Array(await bbs_bls12_381_shake_256_proof_gen(request));
    },

    async verifyProof(request: unknown) {
      await ensureInitialized();
      return bbs_bls12_381_shake_256_proof_verify(request);
    },
  },
};
